export const required = value => (value == null ? 'Campo richiesto' : undefined)

export const money = value =>
  (!isNaN(+value) && +value > 0
    ? undefined
    : 'Inserire un importo di denaro valido')

export const email = value =>
  (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Indirizzo mail non valido'
    : undefined)

export const zip = value =>
  (value && !/^\d{5}$/.test(value) ? 'CAP non valido' : undefined)

export const maxLength = maxLen => value =>
  (value && value.length > maxLen
    ? `Lunghezza massima consentita ${maxLen}`
    : undefined)

export const accepted = value =>
  (value === true ? undefined : 'Devi accettare termini e condizioni')

export const passRegex = r => value =>
  // FIXME: I know, i know, i know
  // I am a teppista and eval is evil like capitalism but...
  // How can convert plain string into regex? new RegExp() escape // and
  // dont care about flags like /i , so eval is do the right job
  // open for better solutions...
  (value && !eval(r).test(value) ? 'Formato invalido' : undefined)



// WEBPACK FOOTER //
// ./src/form/validation.js